export default __webpack_public_path__ + "static/media/footer-illustration.29d07b6f.svg";